import { ParagraphDto, ParagraphSummaryDto } from './paragraph.model';
import { Paragraph } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapParagraph(paragraphDto: ParagraphDto): Paragraph {
  return {
    id: paragraphDto.id,
    name: paragraphDto.name,
    position: paragraphDto.position,
    theory: paragraphDto.theory,
    bookId: paragraphDto.book.id,
    chapterId: paragraphDto.chapter.id,
    nextParagraphId: paragraphDto.next?.id,
    previousParagraphId: paragraphDto.previous?.id,
    videoIds: paragraphDto.videos.map((video) => video.id),
    exerciseIds: paragraphDto.exercises.map((exercise) => exercise.id),
  };
}

export function mapParagraphSummary(
  paragraphDto: ParagraphSummaryDto,
  bookId: string,
  chapterId: string,
): Paragraph {
  return {
    id: paragraphDto.id,
    name: paragraphDto.name,
    position: paragraphDto.position,
    bookId,
    chapterId,
  };
}
